import { useEffect, useRef } from "react";

function useParallax(factor = 0.1, limite = 30) {
  const ref = useRef(null);

  useEffect(() => {
    const prefiereMenosMovimiento = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (prefiereMenosMovimiento) return;

    let frame = null;

    const actualizar = () => {
      frame = null;
      const el = ref.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const centro = rect.top + rect.height / 2 - window.innerHeight / 2;
      const desplazamiento = Math.max(
        -limite,
        Math.min(limite, centro * -factor)
      );
      el.style.transform = `translateY(${desplazamiento}px)`;
    };

    const solicitarActualizacion = () => {
      if (frame === null) {
        frame = requestAnimationFrame(actualizar);
      }
    };

    actualizar();
    window.addEventListener("scroll", solicitarActualizacion, { passive: true });
    window.addEventListener("resize", solicitarActualizacion);

    return () => {
      window.removeEventListener("scroll", solicitarActualizacion);
      window.removeEventListener("resize", solicitarActualizacion);
      if (frame !== null) cancelAnimationFrame(frame);
    };
  }, [factor, limite]);

  return ref;
}

export default useParallax;
